import type { ReactNode } from "react";
import Header from "./Header";

interface PageShellProps {
  children: ReactNode;
  showHero?: boolean;
}

const PageShell = ({ children, showHero = false }: PageShellProps) => {
  return (
    <div className="min-h-screen bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-white via-gray-50 to-white p-8 relative">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(70,139,255,0.35)_1px,transparent_0)] bg-[length:24px_24px] bg-center"></div>
      <div className="max-w-5xl mx-auto space-y-8 relative">
        <Header showHero={showHero} />
        {children}
      </div>
    </div>
  );
};

export default PageShell;
